import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { RequestService } from '~/app/core/services/request.service';

@Component({
  selector: 'app-discussion-box',
  templateUrl: './discussion-box.component.html',
  styleUrls: ['./discussion-box.component.scss']
})
export class DiscussionBoxComponent implements OnInit {
  @Input() requestId;
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  @ViewChildren('item') itemElements: QueryList<any>;
  form: FormGroup = new FormGroup({ message: new FormControl()});
  comments: any;
  total: number;
  toggle = false;
  regex = /\.(?:jpe?g|png|gif)(?:$|[?#])/;

  constructor(private requestService: RequestService) { }

  ngOnInit(): void {
    this.getComments();
    const ele = document.getElementById('message');
    if (!ele) { return; }
    ele.addEventListener('keydown', (e) => {
      // 13 represents the Enter key
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
      }
    });
  }

  onSubmit(f): void {
    this.form.get('message').setValue('');
    const params = {
      comment: f.message,
    };
    this.requestService.postComment(this.requestId, params).subscribe(res => {
      this.getComments();
    });
  }

  getComments(): void{
    this.requestService.getCommentsById(this.requestId).subscribe(res => {
      this.comments = res.data;
      this.total = res.total;
      this.itemElements.changes.subscribe(_ => this.onItemElementsChanged());
    });
  }

  onClick(): void {
    this.toggle = !this.toggle;
  }

  isImg(link: string): boolean {
    return this.regex.test(link);
  }

  public onItemElementsChanged(): void {
    if (!this.toggle) { return; }
    this.scrollToBottom();
  }

  public scrollToBottom(): void {
    this.myScrollContainer.nativeElement.scroll({
      top: this.myScrollContainer.nativeElement.scrollHeight,
    });
  }

  showTime(dateTime): string {
    const formatter = new Intl.DateTimeFormat('en', {
      day: '2-digit',
      month: 'long',
      hour: 'numeric',
      minute: 'numeric',
    });
    const today = new Date(dateTime);
    const [day, month, time] = formatter.format(today).split(', ');
    const dayOfMonth = ['1', '21', '31'].includes(day) ? 'st' : ['2', '22'].includes(day) ? 'nd' : ['3', '23'].includes(day) ? 'rd' : 'th';
    return `${month} ${day}${dayOfMonth}, ${time}`.replace('AM', 'am').replace('PM', 'pm');
  }
}
